import { z } from 'zod';
import { accountBadgeAccountRequestSchema } from '../schema/commonRequestSchema';
import { accountBadgeResponseSchema } from '../schema/commonResponseSchema';
export const createAccountBadgeRequestSchema = z.object({
    badgeId: z.string().uuid(),
    accounts: accountBadgeAccountRequestSchema.array(),
});
export const createAccountBadgeResponseSchema = z.object({
    accountBadges: accountBadgeResponseSchema.array(),
});
export const createAccountBadgeFunctionDef = {
    name: 'createAccountBadge',
    requestSchema: createAccountBadgeRequestSchema,
    responseSchema: createAccountBadgeResponseSchema,
};
